import { Component, OnChanges, Input, inject } from "@angular/core";

import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
import { DvsChartComponent } from "src/app/shared/dvs-chart/dvs-chart.component";
import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-gear-detail",
	templateUrl: "./gear-detail.component.html",
	styleUrls: ["./gear-detail.component.scss"],
	imports: [DvsChartComponent]
})
export class GearDetailComponent implements OnChanges {
	private api = inject(ApiService);
	private charting = inject(ChartingService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	component: AssemblyConfig.Gear;
	@Input()
	shaft: AssemblyConfig.Shaft;
	@Input()
	raw: APIResults.RawPairsResult;

	public residualoptions?: Highcharts.Options;
	public amresoptions?: Highcharts.Options;
	public amoptions?: Highcharts.Options;
	public fmoptions?: Highcharts.Options;
	public energyoptions?: Highcharts.Options;
	public errormessage: string;

	async ngOnChanges() {
		if (this.asset && this.component && this.raw) {
			this.residualoptions = undefined;
			this.amresoptions = undefined;
			this.amoptions = undefined;
			this.fmoptions = undefined;
			this.energyoptions = undefined;
			this.errormessage = undefined;
			try {
				const result = await this.api.GetGearVibe(this.asset.asset_id, this.component.id, this.raw.tachrawid, this.raw.viberawid);
				this.residualoptions = this.charting.RevolutionDefaults("Residual", result.resstats, result.rpm, result.res, "Gs");
				this.amresoptions = this.charting.RevolutionDefaults("AM Residual", result.amresstats, result.rpm, result.amres, "Gs");
				this.amoptions = this.charting.RevolutionDefaults("AM Analysis", result.amstats, result.rpm, result.am, "Gs");
				this.fmoptions = this.charting.RevolutionDefaults("FM Analysis", result.fmstats, result.rpm, result.fm, "Gs");
				this.energyoptions = this.charting.RevolutionDefaults("Energy", result.eostats, result.rpm, result.eo, "E");
			} catch (err) {
				this.errormessage = "Unable to load gear vibe";
				console.error("Couldn't load gear vibe");
				console.log(err);
			}
		}
	}
}
